import React from "react";
import Routes from "../components/common/Router";

const Main = () => (
  <div>
    <Routes />
  </div>
);

export default Main;
